var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React from 'react';
import styled from '@emotion/styled';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import Drawer from '../../common/components/Drawer';
import NavigationList, { NavigationLine } from './NavigationList';
import { SideNavSubscription } from '../../common/event-bus/EventSubscription';
import { LocaleConsumer } from '../../common/providers/LocaleProvider';
import { ItemPropType, } from '../../common/prop-types/NavigationItem';
import LanguageSwitch from './LanguageSwitch';
import BottomNavigationSection from './BottomNavigationSection';
import { space, padding, margin, font, absolute, color, } from '../../common/theme/helper';
import arrowStrongRight from '../../common/assets/icons/arrow-strong-right.svg';
import closeStrongSmall from '../../common/assets/icons/close-strong-small.svg';
var AbsoluteButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  ", ";\n  ", ";\n  width: ", ";\n  height: ", ";\n  border: none;\n  background: none;\n"], ["\n  position: absolute;\n  ", ";\n  ", ";\n  width: ", ";\n  height: ", ";\n  border: none;\n  background: none;\n"])), margin(0), padding(0), space(6), space(6));
var BackButton = styled(AbsoluteButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), absolute(0, null, null, 0));
var CloseButton = styled(AbsoluteButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), absolute(0, 0, null, null));
var ArrowBack = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n  max-width: ", ";\n  height: ", ";\n  max-height: ", ";\n  transform: rotate(180deg);\n"], ["\n  width: ", ";\n  max-width: ", ";\n  height: ", ";\n  max-height: ", ";\n  transform: rotate(180deg);\n"])), space(4), space(4), space(4), space(4));
ArrowBack.defaultProps = {
    src: arrowStrongRight,
    role: 'presentation',
};
var CloseIcon = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 12px;\n  max-width: 12px;\n  height: 12px;\n  max-height: 12px;\n  padding: 2px;\n  box-sizing: content-box;\n"], ["\n  width: 12px;\n  max-width: 12px;\n  height: 12px;\n  max-height: 12px;\n  padding: 2px;\n  box-sizing: content-box;\n"])));
CloseIcon.defaultProps = {
    src: closeStrongSmall,
    role: 'presentation',
};
var Header = styled(NavigationLine)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: relative;\n  position: sticky;\n  top: 0;\n  justify-content: center;\n  background-color: #fff;\n"], ["\n  position: relative;\n  position: sticky;\n  top: 0;\n  justify-content: center;\n  background-color: #fff;\n"])));
var Heading = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"], ["\n  ", ";\n  ", ";\n  font-weight: bold;\n  color: ", ";\n"])), padding(0, 6), font(5), color('text'));
var SideNav = /** @class */ (function (_super) {
    __extends(SideNav, _super);
    function SideNav(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            // currentNavigation is a pointer to the current
            // navigation item. It is an array that points to
            // the sequence of [groupId, itemId] items that you
            // need to follow to get to the current category
            currentNavigation: [],
        };
        _this.onNavigationClick = _this.onNavigationClick.bind(_this);
        _this.onBackButtonClick = _this.onBackButtonClick.bind(_this);
        return _this;
    }
    SideNav.prototype.onNavigationClick = function (event) {
        var _a = event.currentTarget.dataset, groupId = _a.groupId, itemId = _a.itemId;
        this.setState(function (prevState) { return ({
            // on navigation click we will add another pointer
            // to the chain of pointers
            currentNavigation: __spread(prevState.currentNavigation, [[groupId, itemId]]),
        }); });
    };
    SideNav.prototype.onBackButtonClick = function () {
        this.setState(function (prevState) {
            var pointer = __spread(prevState.currentNavigation);
            // on back button click we will
            // remove the last item from the cursor
            pointer.pop();
            return {
                currentNavigation: pointer,
            };
        });
    };
    SideNav.prototype.getNavigationData = function (pointer) {
        // to get the current navigation data
        // we will go through all pointers to
        // get the latest item in the chain
        return pointer.reduce(function (data, next) { return data.children[next[0]][next[1]]; }, this.props.navigation);
    };
    SideNav.prototype.getCurrentNavigationData = function () {
        return this.getNavigationData(this.state.currentNavigation);
    };
    SideNav.prototype.getParentNavigationData = function () {
        var pointer = __spread(this.state.currentNavigation);
        // remove the last item from the cursor
        pointer.pop();
        return this.getNavigationData(pointer);
    };
    SideNav.prototype.getCurrentNavigationLevel = function () {
        return this.state.currentNavigation.length;
    };
    SideNav.prototype.isRootLevel = function () {
        return this.state.currentNavigation.length === 0;
    };
    SideNav.prototype.render = function () {
        var _this = this;
        var navigation = this.getCurrentNavigationData();
        return (React.createElement(SideNavSubscription, null, function (_a) {
            var value = _a.value, emit = _a.emit;
            return (React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(Drawer, { isOpen: value, isSideNav: true, onBackdropClick: function () { return emit(false); } },
                React.createElement(Header, { as: "header" },
                    !_this.isRootLevel() && (React.createElement(BackButton, __assign({}, getTrackerProps({
                        'aria-label': l10n.r(l10n.t('h24_back_to_category'), {
                            name: _this.getParentNavigationData().name,
                        }),
                        'data-testid': 'sidenav-back-button',
                        onClick: _this.onBackButtonClick,
                    }, {
                        event: 'navigation',
                        eventData: {
                            placement: 'slidingMenu',
                            iconIdentifier: 'back',
                        },
                    })),
                        React.createElement(ArrowBack, null))),
                    React.createElement(Heading, { "data-testid": "sidenav-heading" }, _this.isRootLevel() ? l10n.t('h24_menu') : navigation.name),
                    React.createElement(CloseButton, __assign({}, getTrackerProps({
                        'aria-label': l10n.t('h24_close_menu'),
                        'data-testid': 'sidenav-close-button',
                        onClick: function () { return emit(false); },
                    }, {
                        event: 'navigation',
                        eventData: {
                            placement: 'slidingMenu',
                            iconIdentifier: 'close',
                        },
                    })),
                        React.createElement(CloseIcon, null))),
                React.createElement(NavigationList, { navigation: navigation, onNavigationClick: _this.onNavigationClick, navLevel: _this.getCurrentNavigationLevel() }),
                React.createElement(BottomNavigationSection, null),
                React.createElement(LanguageSwitch, { languages: l10n.languages().map(function (item) { return (__assign({}, item, { language: l10n.t("h24_language_" + item.language) })); }) }))); }));
        }));
    };
    SideNav.propTypes = {
        /** Navigation panel items tree. */
        navigation: ItemPropType,
    };
    return SideNav;
}(React.Component));
export default SideNav;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
